import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const deleteFeatureRequest = {
  name: "deleteFeatureRequest" as const,
  input: z.object({ requestId: zExt.objectId() }),
  output: z.object({ success: z.boolean() }),
};
